
import { DocumentContentEditor } from "./DocumentContentEditor";

interface TechArchitectureViewProps {
  content: any;
  documentId: string;
  onUpdate: () => void;
}

export function TechArchitectureView({ content, documentId, onUpdate }: TechArchitectureViewProps) {
  return (
    <div className="space-y-8">
      <section className="bg-white rounded-lg p-6 shadow-sm">
        <h2 className="text-2xl font-semibold mb-4">System Overview</h2>
        <DocumentContentEditor
          section="System Overview"
          content={content.systemOverview}
          documentId={documentId}
          field="systemOverview"
          onUpdate={onUpdate}
        />
      </section>

      <section className="bg-white rounded-lg p-6 shadow-sm">
        <h2 className="text-2xl font-semibold mb-4">Architecture Diagram</h2>
        <DocumentContentEditor
          section="Architecture Diagram"
          content={content.architectureDiagram}
          documentId={documentId}
          field="architectureDiagram"
          onUpdate={onUpdate}
        />
      </section>

      <section className="bg-white rounded-lg p-6 shadow-sm">
        <h2 className="text-2xl font-semibold mb-4">Technology Stack</h2>
        <DocumentContentEditor
          section="Technology Stack"
          content={content.technologyStack}
          documentId={documentId}
          field="technologyStack"
          onUpdate={onUpdate}
        />
      </section>

      <section className="bg-white rounded-lg p-6 shadow-sm">
        <h2 className="text-2xl font-semibold mb-4">Security Framework</h2>
        <DocumentContentEditor
          section="Security Framework"
          content={content.securityFramework}
          documentId={documentId}
          field="securityFramework"
          onUpdate={onUpdate}
        />
      </section>

      <section className="bg-white rounded-lg p-6 shadow-sm">
        <h2 className="text-2xl font-semibold mb-4">Scalability Plan</h2>
        <DocumentContentEditor
          section="Scalability Plan"
          content={content.scalabilityPlan}
          documentId={documentId}
          field="scalabilityPlan"
          onUpdate={onUpdate}
        />
      </section>

      <section className="bg-white rounded-lg p-6 shadow-sm">
        <h2 className="text-2xl font-semibold mb-4">Integration Points</h2>
        <DocumentContentEditor
          section="Integration Points"
          content={content.integrationPoints}
          documentId={documentId}
          field="integrationPoints"
          onUpdate={onUpdate}
        />
      </section>
    </div>
  );
}
